module.exports = {
  replace: require("./replace"),
  detect: require("./detect")
};